// Utility functions for MemberDetails components

// Helper function to mask sensitive data - show only last 4 digits with ***** prefix
export const maskSensitiveData = (value) => {
  if (!value) return "—";
  const valueStr = value.toString();
  if (valueStr.length <= 4) return valueStr;
  return `*****${valueStr.slice(-4)}`;
};

// Helper function to extract NPA (area code) from phone number
export const getNpaFromPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";
  // Remove all non-digit characters
  const digitsOnly = phoneNumber.replace(/\D/g, "");
  // Return first 3 digits (NPA/area code)
  return digitsOnly.substring(0, 3);
};

// Validation helper functions
export const isValidEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const isValidPhoneNumber = (phone) => {
  // Remove all non-digit characters
  const digitsOnly = phone.replace(/\D/g, "");
  // Valid phone number should be 10 or 11 digits
  return digitsOnly.length === 10 || digitsOnly.length === 11;
};
